import webApiAdmin from '@/lib/api-common/webApiAdmin';

export type AsyncRequestResult<T = unknown> =
  | { status: 'pending' }
  | { status: 'done'; result: T }
  | { status: 'failed'; errorMessage: string }
  | { status: 'timedout' };

/**
 * Generic poller for any async delegation request created via a
 * `requestAsync`-style enqueue call (e.g. `updateChannelInstantly` in
 * panel.api.ts). Not channel/feature-specific — reusable by any future
 * delegation-backed action, hence its own file rather than living in
 * panel.api.ts.
 * - New: POST /admin/async-request/get-result
 *
 * Uses `postSilent`: this is called repeatedly on an interval while polling,
 * so a transient miss must not trigger the global error alert (the caller
 * decides how to surface a persistent failure).
 */
export async function getAsyncResult<T = unknown>(
  requestId: string,
): Promise<AsyncRequestResult<T>> {
  return webApiAdmin.postSilent('admin/async-request/get-result', { requestId });
}
